import React, { useState } from 'react';
import Icon from '../../components/AppIcon';

const ACCENT = '#34D399';
const GOLD = '#D6EF4E';

const PendingBadge = () => (
  <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg"
    style={{ background: 'rgba(251,191,36,0.08)', border: '1px solid rgba(251,191,36,0.20)' }}>
    <div className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse" />
    <span className="font-oranienbaum text-amber-400 text-xs tracking-widest uppercase">Pendiente de conexión con Supabase</span>
  </div>
);

const statuses = [
  { key: 'pendiente_pago', label: 'Pend. Pago', color: '#94A3B8', count: 0 },
  { key: 'pagado', label: 'Pagado', color: '#60A5FA', count: 0 },
  { key: 'preparacion', label: 'En Preparación', color: GOLD, count: 0 },
  { key: 'preparado', label: 'Preparado', color: '#FB923C', count: 0 },
  { key: 'enviado', label: 'Enviado', color: '#A78BFA', count: 0 },
  { key: 'entregado', label: 'Entregado', color: ACCENT, count: 0 },
  { key: 'cancelado', label: 'Cancelado', color: '#F87171', count: 0 },
  { key: 'devuelto', label: 'Devuelto', color: '#F87171', count: 0 },
  { key: 'incidencia', label: 'Incidencia', color: '#FBBF24', count: 0 },
];

const columns = ['Número', 'Fecha', 'Cliente', 'Importe', 'Pago', 'Transporte', 'Estado', 'Tracking', 'Responsable'];
const pageSizes = [25, 50, 100];

const PedidosWeb = () => {
  const [activeStatus, setActiveStatus] = useState('todos');
  const [search, setSearch] = useState('');
  const [pageSize, setPageSize] = useState(25);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  return (
    <div className="min-h-screen px-4 py-6 md:px-8" style={{ background: 'linear-gradient(135deg, #0A0A0A 0%, #111111 50%, #0D0D0D 100%)' }}>
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <div className="flex items-center gap-3 mb-1">
            <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: `${ACCENT}15`, border: `1px solid ${ACCENT}30` }}>
              <Icon name="ShoppingCart" size={18} style={{ color: ACCENT }} />
            </div>
            <h1 className="font-oranienbaum font-bold text-white text-2xl md:text-3xl tracking-wide">Pedidos Web</h1>
          </div>
          <p className="font-oranienbaum text-white/40 text-sm ml-12">Centro de preparación y expedición</p>
        </div>
        <PendingBadge />
      </div>
      {/* Status Pipeline */}
      <div className="mb-6 overflow-x-auto pb-2">
        <div className="flex gap-2 min-w-max">
          <button
            onClick={() => setActiveStatus('todos')}
            className="flex flex-col items-center gap-1.5 px-4 py-3 rounded-xl transition-all"
            style={activeStatus === 'todos'
              ? { background: `${ACCENT}15`, border: `1px solid ${ACCENT}30` }
              : { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}>
            <span className="font-oranienbaum font-bold text-white text-lg">0</span>
            <span className="font-oranienbaum text-xs" style={{ color: activeStatus === 'todos' ? ACCENT : 'rgba(255,255,255,0.40)' }}>Todos</span>
          </button>
          {statuses?.map(s => (
            <button
              key={s?.key}
              onClick={() => setActiveStatus(s?.key)}
              className="flex flex-col items-center gap-1.5 px-4 py-3 rounded-xl transition-all"
              style={activeStatus === s?.key
                ? { background: `${s?.color}15`, border: `1px solid ${s?.color}35` }
                : { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}>
              <span className="font-oranienbaum font-bold text-white text-lg">{s?.count}</span>
              <span className="font-oranienbaum text-xs whitespace-nowrap" style={{ color: activeStatus === s?.key ? s?.color : 'rgba(255,255,255,0.40)' }}>{s?.label}</span>
            </button>
          ))}
        </div>
      </div>
      {/* Toolbar */}
      <div className="flex flex-col sm:flex-row gap-3 mb-4">
        <div className="relative flex-1">
          <Icon name="Search" size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
          <input
            type="text"
            placeholder="Buscar por número, cliente, tracking..."
            value={search}
            onChange={e => setSearch(e?.target?.value)}
            className="w-full pl-9 pr-4 py-2.5 rounded-xl text-sm font-oranienbaum text-white/80 placeholder-white/25 outline-none"
            style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.10)' }}
          />
        </div>
        <div className="flex items-center gap-2">
          <input type="date" value={dateFrom} onChange={e => setDateFrom(e?.target?.value)}
            className="px-3 py-2.5 rounded-xl text-xs font-oranienbaum text-white/60 outline-none"
            style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.10)' }} />
          <span className="text-white/30 text-xs font-oranienbaum">—</span>
          <input type="date" value={dateTo} onChange={e => setDateTo(e?.target?.value)}
            className="px-3 py-2.5 rounded-xl text-xs font-oranienbaum text-white/60 outline-none"
            style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.10)' }} />
          <button className="flex items-center gap-2 px-3 py-2.5 rounded-xl text-xs font-oranienbaum transition-all"
            style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.10)', color: 'rgba(255,255,255,0.60)' }}>
            <Icon name="Download" size={14} />
            Exportar
          </button>
        </div>
      </div>
      {/* Filters */}
      <div className="flex flex-wrap gap-2 mb-4">
        {['Pago', 'Transporte', 'Responsable', 'Importe']?.map(f => (
          <button key={f} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-oranienbaum transition-all"
            style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.45)' }}>
            <Icon name="Filter" size={11} />
            {f}
            <Icon name="ChevronDown" size={11} />
          </button>
        ))}
      </div>
      {/* Table */}
      <div className="rounded-2xl overflow-hidden mb-4" style={{ border: '1px solid rgba(255,255,255,0.07)' }}>
        <div className="px-4 py-3 flex items-center justify-between" style={{ background: 'rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
          <div className="flex items-center gap-3">
            <input type="checkbox" className="w-4 h-4 accent-[#34D399]" />
            <span className="font-oranienbaum text-white/50 text-xs">0 pedidos</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-oranienbaum text-white/30 text-xs">Filas:</span>
            {pageSizes?.map(s => (
              <button key={s} onClick={() => setPageSize(s)}
                className="px-2 py-1 rounded text-xs font-oranienbaum transition-all"
                style={pageSize === s ? { background: `${ACCENT}20`, color: ACCENT } : { color: 'rgba(255,255,255,0.35)' }}>
                {s}
              </button>
            ))}
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-max">
            <thead>
              <tr style={{ background: 'rgba(255,255,255,0.02)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                <th className="px-3 py-3 text-left w-8"><input type="checkbox" className="w-3.5 h-3.5 accent-[#34D399]" /></th>
                {columns?.map(col => (
                  <th key={col} className="px-3 py-3 text-left whitespace-nowrap">
                    <button className="flex items-center gap-1 font-oranienbaum text-white/40 text-xs uppercase tracking-wider hover:text-white/70 transition-colors">
                      {col}
                      <Icon name="ChevronsUpDown" size={10} />
                    </button>
                  </th>
                ))}
                <th className="px-3 py-3 text-left">
                  <span className="font-oranienbaum text-white/40 text-xs uppercase tracking-wider">Acciones</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={columns?.length + 2} className="px-4 py-16 text-center">
                  <div className="flex flex-col items-center gap-3">
                    <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ background: 'rgba(52,211,153,0.08)', border: '1px solid rgba(52,211,153,0.15)' }}>
                      <Icon name="ShoppingCart" size={24} className="text-[#34D399]/40" />
                    </div>
                    <p className="font-oranienbaum text-white/40 text-sm">Pendiente de conexión con Supabase</p>
                    <p className="font-oranienbaum text-white/20 text-xs">Los pedidos aparecerán aquí una vez conectada la base de datos</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="px-4 py-3 flex items-center justify-between" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <span className="font-oranienbaum text-white/30 text-xs">0 – 0 de 0 resultados</span>
          <div className="flex items-center gap-1">
            <button className="p-1.5 rounded-lg text-white/30 hover:text-white/60 transition-colors" style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
              <Icon name="ChevronLeft" size={14} />
            </button>
            <span className="px-3 py-1 rounded-lg font-oranienbaum text-xs" style={{ background: `${ACCENT}15`, color: ACCENT }}>1</span>
            <button className="p-1.5 rounded-lg text-white/30 hover:text-white/60 transition-colors" style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
              <Icon name="ChevronRight" size={14} />
            </button>
          </div>
        </div>
      </div>
      {/* Bulk Actions */}
      <div className="flex flex-wrap gap-2">
        {['Cambiar estado', 'Imprimir', 'Generar etiquetas', 'Añadir tracking', 'Registrar incidencia', 'Cancelar', 'Reembolsar']?.map(action => (
          <button key={action} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-oranienbaum transition-all"
            style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.45)' }}>
            {action}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PedidosWeb;
